import {Options as APIOptions} from "@ym-framework/api-utils";
import PluginMock from "@ym-framework/api-utils-mock";
import PluginModelResponse from "@ym-framework/api-utils-model-response";
import {mocks} from "@/mock";
if (process.env.YM_LOCAL_MOCK) {
  const _mocks = mocks;
  APIOptions.plugins.install(new PluginMock((mock) => {
    for (const _mock of _mocks) {
      _mock(mock);
    }
  }));
}
APIOptions.plugins.install(new PluginModelResponse());
APIOptions.host.set("base", () => {
  return {
    baseURL: "https://api.kuajingvs.com",
    headers: {
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "X-Client-Ver": "6.5.7",
      "X-Patch-Ver": "6.5.7"
    }
  };
});
APIOptions.host.set("base.auth", () => {
  return {
    baseURL: "https://api.kuajingvs.com",
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("authenticationToken") || "",
      "X-LANG": localStorage.getItem("lang") || "zh-CN",
      "X-Client-Ver": "6.5.7",
      "X-Patch-Ver": "6.5.7"
    }
  };
});
